module.exports = __webpack_public_path__ + "01d26a2ee9e5613f01b06732594e05d0.png";